import React, { useState, useContext, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import "../../css/phoneauth.css";

// Premium Vyango Logo (Sleek Map Pin / Route)
const BrandLogo = () => (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="travelo-logo-svg">
    <polygon points="3 11 22 2 13 21 11 13 3 11" fill="var(--flow-primary)" stroke="var(--flow-primary)"></polygon>
  </svg>
);

export default function PhoneAuth() {
  const { saveUser } = useContext(AuthContext) || { saveUser: () => {} };
  const navigate = useNavigate();

  const [mode, setMode] = useState("signup");
  const [msg, setMsg] = useState("");
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (mode === "login") {
      document.title = "Log In - Vyango";
    } else {
      document.title = "Sign Up - Vyango";
    }
  }, [mode]);

  const showError = (message) => {
    setMsg(message);
    setIsError(true);
    setTimeout(() => setMsg(""), 4000);
  };

  const handleAuthSuccess = (data) => {
    const userObj = data?.user || data?.data?.user || data?.result;
    const token = data?.token;

    if (data?.success && userObj) {
      saveUser(userObj);
      if (token) localStorage.setItem("travelo_token", token);
      localStorage.setItem("travelo_user", JSON.stringify(userObj));
      navigate("/", { replace: true });
    } else {
      showError("Authentication Failed. Please try again.");
    }
  };

  const switchMode = (newMode) => {
    setMode(newMode);
    setMsg(""); // Clear errors on switch
  };

  return (
    <div className="flow-master-layout">
      {/* Decorative Background Elements */}
      <div className="bg-shape shape-1"></div>
      <div className="bg-shape shape-2"></div>

      <div className="flow-master-card">
        
        {/* Floating Toast Notification */}
        {msg && (
          <div className={`flow-toast ${isError ? 'toast-err' : 'toast-success'}`}>
            <span className="toast-icon">{isError ? '⚠️' : '✅'}</span>
            <p>{msg}</p>
          </div>
        )}

        <div className="flow-master-header">
          <BrandLogo />
          <h1>{mode === 'login' ? 'Welcome back' : 'Join Vyango'}</h1>
        </div>

        <div className="flow-master-body">
          {mode === "login" ? (
            <LoginForm showError={showError} handleAuthSuccess={handleAuthSuccess} />
          ) : (
            <SignupForm showError={showError} handleAuthSuccess={handleAuthSuccess} />
          )}
        </div>

        <div className="flow-master-footer">
          {mode === 'login' ? (
            <p>Don't have an account? <button type="button" onClick={() => switchMode("signup")}>Sign up</button></p>
          ) : (
            <p>Already have an account? <button type="button" onClick={() => switchMode("login")}>Log in</button></p>
          )}
        </div>

      </div>
    </div>
  );
}